import {
  fetchRpStatuses,
  fetchRpLaunches,
  RpStatusResponse,
  RpLaunchesResult,
} from "@/api/reportPortal/client"

class RpStatusServiceClass {
  // Never throws: RP status is additive - any failure degrades to "no
  // live status" without disturbing the drift table.
  async getStatuses(filters: string[]): Promise<RpStatusResponse | null> {
    try {
      const response = await fetchRpStatuses([...new Set(filters)])
      // Vite's dev-server SPA fallback answers /api/* with index.html (200),
      // which axios happily resolves - guard the shape so a non-JSON body
      // degrades to the unavailable banner instead of crashing the render.
      if (
        typeof response !== "object" ||
        response === null ||
        typeof response.fetchedAt !== "string" ||
        typeof response.results !== "object" ||
        response.results === null
      ) {
        return null
      }
      return response
    } catch {
      return null
    }
  }

  // Never throws: same additive contract as getStatuses.
  async getLaunches(count: number): Promise<RpLaunchesResult | null> {
    try {
      const response = await fetchRpLaunches(count)
      if (
        typeof response !== "object" ||
        response === null ||
        typeof response.launches !== "object" ||
        response.launches === null ||
        !Array.isArray(response.launches.runs)
      ) {
        return null
      }
      return response.launches
    } catch {
      return null
    }
  }
}

export const RpStatusService = new RpStatusServiceClass()
